// import { BaseQueryArg } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { IFoundProductData } from '../../model/IFoundProduct'
import { ISettings } from '../../model/ISettings'
import api from './api'

export interface IAddImportProductsResponse {
  count: number
}

export const settingsApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateSettings: build.mutation<ISettings, ISettings>({
      query: (body) => ({
        url: '/settings',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['settings'],
    }),

    getSettings: build.query<ISettings, unknown>({
      query: () => ({
        url: '/settings',
      }),
      providesTags: ['settings'],
    }),
  }),
})
